import type { SuspenseDataBoundaryLoaderSpec } from './types';
import type { ReactNode, FC } from 'react';

export function createSuspenseDataBoundary<TData>(spec: SuspenseDataBoundaryLoaderSpec<TData>) {
  const useBoundaryData = () => {
    return spec.useBoundaryData();
  };

  const BoundaryLoader: FC<{ children: (data: TData) => ReactNode }> = ({ children }) => {
    const data = useBoundaryData();
    return <>{children(data)}</>;
  };

  return { useBoundaryData, BoundaryLoader };
}
